import { Instance } from 'mobx-state-tree';
import { CustomerNotificationTemplatePlaceholdersDtoModelBase } from './CustomerNotificationTemplatePlaceholdersDtoModel.base';

/* The TypeScript type of an instance of CustomerNotificationTemplatePlaceholdersDtoModel */
export interface CustomerNotificationTemplatePlaceholdersDtoModelType extends Instance<typeof CustomerNotificationTemplatePlaceholdersDtoModel.Type> {}

/* A graphql query fragment builders for CustomerNotificationTemplatePlaceholdersDtoModel */
export {
  selectFromCustomerNotificationTemplatePlaceholdersDto,
  customerNotificationTemplatePlaceholdersDtoModelPrimitives,
  CustomerNotificationTemplatePlaceholdersDtoModelSelector,
} from './CustomerNotificationTemplatePlaceholdersDtoModel.base';

/**
 * CustomerNotificationTemplatePlaceholdersDtoModel
 */
export const CustomerNotificationTemplatePlaceholdersDtoModel = CustomerNotificationTemplatePlaceholdersDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
